import gql from 'graphql-tag';

const SEGMENT_DELETE = gql`
mutation segmentDelete ($id: ID!) {
  segmentDelete (id: $id)
}
`;

export default SEGMENT_DELETE;